import { createStore, createSelectors } from "@kanda-libs/ks-frontend-services";
import { type PageKeys, pages } from "components/shared/App";

export const store = createStore<PageKeys>();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const selectors = createSelectors<RootState, typeof pages>();
